/* MolCellQuest — 画面演出（紙吹雪・浮き上がる数値・トースト）
   紙吹雪だけ Canvas、それ以外は使い捨ての DOM 要素 + CSS アニメーション。 */

let particles = [];
let animId = null;

/** 全画面キャンバスのサイズを合わせる（devicePixelRatio 対応） */
export function setupCanvas() {
  const cv = document.getElementById("fx");
  if (!cv) return null;
  const dpr = Math.min(2, window.devicePixelRatio || 1);
  cv.width = Math.floor(window.innerWidth * dpr);
  cv.height = Math.floor(window.innerHeight * dpr);
  const ctx = cv.getContext("2d");
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  return ctx;
}

const CONFETTI_COLORS = ["#4fd1a5", "#7bd8ff", "#ffce5a", "#ff6b81", "#c9a0ff", "#74c365"];

export function startConfetti(count = 120) {
  if (!document.getElementById("fx")) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  setupCanvas();
  const W = window.innerWidth;
  const H = window.innerHeight;
  particles = [];
  for (let i = 0; i < count; i++) {
    particles.push({
      x: Math.random() * W,
      y: -20 - Math.random() * H * 0.5,
      r: Math.random() * 6 + 4,
      color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
      tilt: Math.random() * 10 - 5,
      tiltAngle: 0,
      tiltSpeed: Math.random() * 0.07 + 0.02,
      vy: Math.random() * 3 + 2,
      vx: Math.random() * 2 - 1,
    });
  }
  if (animId) cancelAnimationFrame(animId);
  drawConfetti();
}

function drawConfetti() {
  const cv = document.getElementById("fx");
  if (!cv) return;
  const ctx = cv.getContext("2d");
  const H = window.innerHeight;
  ctx.clearRect(0, 0, cv.width, cv.height);

  let active = false;
  for (const p of particles) {
    p.tiltAngle += p.tiltSpeed;
    p.y += p.vy;
    p.x += p.vx;
    p.tilt = Math.sin(p.tiltAngle - p.r / 2) * 5;
    if (p.y < H + 20) {
      active = true;
      // リボン状の紙吹雪＝短く太い線分。tilt の sin でひらひら回る。
      ctx.beginPath();
      ctx.lineWidth = p.r;
      ctx.strokeStyle = p.color;
      ctx.moveTo(p.x + p.tilt + p.r / 2, p.y);
      ctx.lineTo(p.x + p.tilt, p.y + p.tilt + p.r / 2);
      ctx.stroke();
    }
  }

  // 全部が画面外に出たらループを自分で止める
  if (active) {
    animId = requestAnimationFrame(drawConfetti);
  } else {
    animId = null;
    ctx.clearRect(0, 0, cv.width, cv.height);
  }
}

/* ── 使い捨ての浮遊要素 ───────────────────────────────── */

function floatEl(cls, html, ms) {
  const el = document.createElement("div");
  el.className = cls;
  el.innerHTML = html;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), ms);
  return el;
}

/** 獲得した進化ポイントを画面中央から浮き上がらせる */
export function floatEvo(text) {
  floatEl("evo-float", `+${text}`, 1500);
}

export function comboFloat(combo) {
  floatEl("combo-float", `⚡ ${combo} COMBO!`, 1300);
}

/* ── トースト ─────────────────────────────────────────── */

let toastTimer = null;

export function showToast(html, seconds = 4) {
  const t = document.getElementById("toast");
  if (!t) return;
  t.innerHTML = html;
  t.classList.add("show");
  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    t.classList.remove("show");
    toastTimer = null;
  }, seconds * 1000);
}

/** 数値を easeOutCubic でカウントアップ／ダウンする */
export function animateNumber(el, from, to, ms, render) {
  if (!el) return;
  if (from === to) {
    el.textContent = render(to);
    return;
  }
  const t0 = performance.now();
  function step(now) {
    const p = Math.min(1, (now - t0) / ms);
    const eased = 1 - Math.pow(1 - p, 3);
    el.textContent = render(from + (to - from) * eased);
    if (p < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}
